import React, {Component} from 'react';

import PropTypes from 'prop-types';
import TableComponentEnum from './../../utils/TableComponentEnum';

class TableRowColumn extends Component {
    constructor() {
        super();
        this.componentType = TableComponentEnum.ROWCOLUMN;
    }


  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string,
    onClick: PropTypes.func,
    colSpan: PropTypes.number
  };

  state = {

  };

    onClick = (event) => {
        if (this.props.onClick) {
            this.props.onClick(event, this.props.columnNumber);
        }
    };

  render() {
    const {
      children,
      id,
      className,
      colSpan,
      rowSpan,
      onClick, // eslint-disable-line no-unused-vars
    } = this.props;

    const handlers = {
      onClick: this.onClick,
    };

    return (
      <th
        className={className}
        id = {id}
        colSpan = {colSpan}
        rowSpan={rowSpan}
        {...handlers}
      >
        {children}
      </th>
    );
  }
}

export default TableRowColumn;
